import classNames from 'classnames/bind';
import { PeriodType, useInfoParamsContext } from 'contexts/infoParams';
import { Dispatch, SetStateAction } from 'react';
import styles from './index.module.scss';

const cx = classNames.bind(styles);

type TopInfoBoxProps = {
  position: string;
  isDirect?: boolean;
  toggleDirect?: Dispatch<SetStateAction<boolean>>;
};

const TopInfoBox = ({ position, isDirect, toggleDirect }: TopInfoBoxProps) => {
  const {
    infoSearchParams: {
      departureCity,
      arrivalCity,
      isDirect: isInfoParamDirect,
      isDomestic,
      period,
    },
    setInfoSearchParams,
  } = useInfoParamsContext();

  const addPeriod = () => {
    if (period > PeriodType.MIN) {
      setInfoSearchParams(prev => ({
        ...prev,
        period: period - 1,
        isProductChange: false,
      }));
    }
  };

  const subtractPeriod = () => {
    if (period < PeriodType.MAX) {
      setInfoSearchParams(prev => ({
        ...prev,
        period: period + 1,
        isProductChange: false,
      }));
    }
  };

  const onClick = () => {
    const currentDirect = isDirect ?? isInfoParamDirect;
    toggleDirect?.(!currentDirect);
    setInfoSearchParams(prev => ({
      ...prev,
      isDirect: !currentDirect,
      isProductChange: false,
    }));
  };

  return (
    <div className={cx('info')}>
      <div className={cx('inner')}>
        <div className={cx('routes')}>
          <span className={cx('start')}>
            <i className={cx('name')}>{departureCity.name}</i>
            <b className={cx('code')}>{departureCity.code}</b>
          </span>
          <span className={cx('end')}>
            <i className={cx('name')}>{arrivalCity.name}</i>
            <b className={cx('code')}>{arrivalCity.code}</b>
          </span>
        </div>
        <div className={cx('chart_schedule')}>
          {!(
            isDomestic ||
            (departureCity.isDomestic && arrivalCity.isDomestic)
          ) && (
            <button
              type="button"
              role="checkbox"
              className={cx('direct')}
              aria-checked={isDirect ?? isInfoParamDirect}
              data-event-nlog="click"
              data-event-area-code={`${position}.${!(isDirect ?? isInfoParamDirect) ? 'directft' : 'directftuc'}`}
              onClick={onClick}
            >
              직항
            </button>
          )}

          <>
            <b className={cx('current')}>{period}일 일정</b>
            <span
              className={cx('spinner')}
              role="spinbutton"
              aria-valuemax={PeriodType.MAX}
              aria-valuemin={PeriodType.MIN}
              aria-valuenow={period}
            >
              <button
                type="button"
                className={cx('inner')}
                aria-disabled={period === PeriodType.MIN}
                data-event-nlog="click"
                data-event-area-code={`${position}.dateminus`}
                onClick={addPeriod}
              />
              <button
                type="button"
                className={cx('outer')}
                aria-disabled={period === PeriodType.MAX}
                data-event-nlog="click"
                data-event-area-code={`${position}.dateplus`}
                onClick={subtractPeriod}
              />
            </span>
          </>
        </div>
      </div>
    </div>
  );
};

export default TopInfoBox;
